import request from '@/utils/request'

export function getBlindBoxList() {
  return request({
    url: 'api/v1/tetris-blind-box/list',
    method: 'post'
  })
}

export function updateBlindBox(data) {
  return request({
    url: 'api/v1/tetris-blind-box/update',
    method: 'post',
    data: data
  })
}

export function exportBlindBox() {
  return request({
    url: 'api/v1/tetris-blind-box/export',
    method: 'get'
  })
}

export function importBlindBox(data) {
  return request({
    url: 'api/v1/tetris-blind-box/import',
    method: 'post',
    data: data
  })
}
